<template>
  <div class="col-12 mt2 p2" :class="[backgroundColor]">
    <div class="flex justify-between pb1">
      <div class="h6 bold">
        <span>{{ sessionDateLabel }}</span>
        <div class="flex flex-wrap">
          <span
            class="cust-border px1 h6 light-cyan-bg mr1 mt1"
            style="background-color: transparent;"
            :style="{ '--cust-border-color': 'black', '--cust-border-radius': '999px', height: '24px' }"
          >
            {{ sessionTime }}
          </span>
        </div>
        <p class="h6 m0 mt1">{{ session.detail.name }}</p>
      </div>
      <div class="flex items-center cust-border white-bg px1 h6" :style="{ '--cust-border-color': 'white', '--cust-border-radius': '999px', height: '24px' }">
        <span class="h6">{{ offerInfo.filliere }}</span>
      </div>
    </div>
    <!-- <div class="flex items-center justify-start">
      <div class="h6 cust-border p1" :style="{ '--cust-border-color': 'black', '--cust-border-radius': '999px' }">
        {{ sessionTime }}
      </div>
      <div class="h6 ml1 black-bg white cust-border p1" :style="{ '--cust-border-color': 'black', '--cust-border-radius': '999px' }">
        Heures creuses
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { frenchTime } from '@/utils/utils';
import { useStore } from '@/store/index';

const props = defineProps({
  session: {
    type: Object,
    required: true
  },
  backgroundColor: {
    type: String,
    default: 'light-cyan-bg'
  },
  borderColor: {
    type: String,
    default: 'light-cyan'
  },
  showBorder: {
    type: Boolean,
    default: false
  }
});

const store = useStore();

const offerInfo = computed(() => store.state.offerInfo);
const siteInfo = computed(() => store.state.siteInfo);

const sessionDateShort = computed(() => frenchTime(props.session.start_date, 'EEEE dd MMMM yyyy', siteInfo.value.timezone));
const sessionDateLabel = computed(() => String(sessionDateShort.value).charAt(0).toUpperCase() + String(sessionDateShort.value).slice(1));

const sessionTime = computed(() => frenchTime(props.session.start_date, 'HH:mm', siteInfo.value.timezone) + frenchTime(props.session.end_date, ' à HH:mm', siteInfo.value.timezone));

</script>
